import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Control, Color, ColorEnvironment, Font, Text, Flexbox, Responsive } from './Styles';

import Image from './Image';
import PrimaryButton from './PrimaryButton';

import Locale from './models/Locale';

const styles = StyleSheet.create({
  container: {
    position: "relative",
    width: 500,
    maxWidth: 'calc(100% - 90px)',
    marginLeft: 10,
    marginRight: 10,
    marginTop: 80,
    paddingTop: 30,
    border: `1px solid ${Color.primary}`,
    borderRadius: 10,
    flexShrink: 0
  },
  circle: {
    position: "absolute",
    height: 130,
    width: 130,
    top: -65,
    left: -65,
    borderRadius: '100%',
    border: `3px solid ${Color.primary}`
  },
  mobileCircle: {
    position: "absolute",
    height: 65,
    width: 65,
    top: -33,
    left: -33,
    borderRadius: '100%',
    border: `3px solid ${Color.primary}`
  }
});


class ScenarioInfo extends Component {
  render() {
    return(
      <div className={css(Flexbox.column, Flexbox.crossCenter)}>
        <Image extraStyles={Control.heroImage} filename={this.props.scenario.path + ".png"} />
        <div className={css(Font.hero)}>{this.props.scenario.name}</div>
        <div className={css(Text.textBlock, Flexbox.grow)}>
          {this.props.scenario.description.split('\n').map((line, i) => {
            return <p key={i}>{line}</p>
          })}
        </div>
        {this.props.scenario.eventsByHazard().map(hazard => {
          return(
            <div className={css(styles.container, Flexbox.column, Flexbox.axisCenter, Flexbox.crossCenter, ColorEnvironment.normal)} key={hazard.hazard}>
              <Image extraStyles={[Responsive.onlyOnMobile, styles.mobileCircle, ColorEnvironment.normal]} filename={hazard.iconFilename}/>
              <Image extraStyles={[Responsive.notOnMobile, styles.circle, ColorEnvironment.normal]} filename={hazard.iconFilename}/>
              <div className={css(Font.heading, Text.heading)}>{hazard.hazard}</div>
              <div className={css(Flexbox.grow, Text.textBlock)}>
                <p>{hazard.hazardDescription}</p>
              </div>
            </div>
          );
        })}
        <div onClick={this.handleDone.bind(this)}>
          <PrimaryButton>{Locale.localized("Let's Play")}</PrimaryButton>
        </div>
      </div>
    );
  }

  handleDone() {
    this.props.onComplete(this.props.event)
  }
}

export default ScenarioInfo;



// WEBPACK FOOTER //
// ./src/ScenarioInfo.js